import { IThreeContextData } from '@src/services/ThreeContext';
import React from 'react';
import * as THREE from 'three';
import { OrbitControls } from 'three/examples/jsm/Addons.js';
import Stats from 'three/examples/jsm/libs/stats.module.js';
import ThreePresentation from '../../ThreePresentation/ThreePresentation';

const ShadowMapScene: React.FC = () => {

    const onStart = React.useCallback(
        (context: IThreeContextData) => {

            context.renderer.setClearColor(0x004488, 1);

            const stats = new Stats();
            stats.dom.style.position = "absolute";

            context.container.appendChild(stats.dom);

            // camera
            context.camera.position.set(1, 1, 1);
            context.camera.rotateY(Math.PI / 4);
            context.camera.rotateX(-Math.PI / 5);

            const controls = new OrbitControls(context.camera, context.canvas);
            controls.enableRotate = true;
            controls.enableZoom = true;
            controls.enablePan = true;
            controls.minDistance = 30;
            controls.maxDistance = 60;
            controls.maxPolarAngle = Math.PI / 2;

            // Scene

            const { renderer, scene, } = context;

            renderer.shadowMap.enabled = true;
            renderer.shadowMap.type = THREE.PCFSoftShadowMap;

            //Create a sphere that cast shadows (but does not receive them)
            const sphereGeometry = new THREE.SphereGeometry(5, 32, 32);
            const sphereMaterial = new THREE.MeshStandardMaterial({ color: 0xff0000 });
            const sphere = new THREE.Mesh(sphereGeometry, sphereMaterial);
            sphere.castShadow = true; //default is false
            sphere.receiveShadow = false; //default
            scene.add(sphere);

            //Create a plane that receives shadows (but does not cast them)
            const planeGeometry = new THREE.PlaneGeometry(40, 40, 32, 32);
            const planeMaterial = new THREE.MeshStandardMaterial({ color: 0x00ff00 })
            const plane = new THREE.Mesh(planeGeometry, planeMaterial);
            plane.receiveShadow = true;
            plane.translateY(-10);
            plane.rotateX(-Math.PI / 2);
            scene.add(plane);

            //Create a DirectionalLight and turn on shadows for the light
            const light = new THREE.DirectionalLight(0xffffff, 1);
            light.position.set(-5, 10, 5); //default; light shining from top
            light.castShadow = true; // default false
            light.target = sphere;
            scene.add(light);

            //Set up shadow properties for the light
            light.shadow.mapSize.width = 512; // default
            light.shadow.mapSize.height = 512; // default
            light.shadow.camera.near = 0.5; // default
            light.shadow.camera.far = 500; // default

            const ambientLight = new THREE.AmbientLight(0x404040);
            scene.add(ambientLight);

            //Create a helper for the shadow camera (optional)
            const helper = new THREE.CameraHelper(light.shadow.camera);
            scene.add(helper);

            return {
                stats,
                controls,
            };
        },
        []
    );

    const onUpdate = React.useCallback(
        (context: IThreeContextData, state: ReturnType<typeof onStart>) => {
            state.controls.update();
            state.stats.update();
        },
        []
    );

    return (
        <div>
            <ThreePresentation
                onStart={onStart}
                onUpdate={onUpdate}
            />
        </div>
    )
};

export default ShadowMapScene;

